import { useContext } from 'react'

import IncidentHighRiskContext from 'contexts/IncidentHighRiskContext'

const useIncidentHighRisk = () => {
  const context = useContext(IncidentHighRiskContext)

  if (context === undefined) {
    throw new Error(
      'useIncidentHighRisk must be used within a IncidentHighRiskContext.Provider',
    )
  }

  return {
    activeButton: context.activeButton,
    activeHighRiskStep: context.activeHighRiskStep,
    handleAdvanceHighRiskStep: context.handleAdvanceHighRiskStep,
    handleHighRiskBack: context.handleHighRiskBack,
    handleHighRiskNext: context.handleHighRiskNext,
    handleReturnHighRiskStep: context.handleReturnHighRiskStep,
    handleHighRiskStep: context.handleHighRiskStep,
    isHighRiskStepCompleted: context.isHighRiskStepCompleted,
    resetAdvanceHighRiskStep: context.resetAdvanceHighRiskStep,
    resetReturnHighRiskStep: context.resetReturnHighRiskStep,
    setActiveButton: context.setActiveButton,
    setActiveHighRiskStep: context.setActiveHighRiskStep,
    setShowButtons: context.setShowButtons,
    showButtons: context.showButtons,
    wantsToAdvanceHighRiskStep: context.wantsToAdvanceHighRiskStep,
    wantsToReturnHighRiskStep: context.wantsToReturnHighRiskStep,
  }
}

export default useIncidentHighRisk
